import { Appendix } from "../../entities/scripts/appendix";
import { Site } from "../../entities/scripts/site";
import { Study } from "../../entities/scripts/study";
import { DoArraysOverlap } from "../array-functions";

export interface IStudyAppendixSiteFilterParent {
    FilterUpdated(studyIds: number[], appendixIds: number[], siteIds: number[]);
}

export class StudyAppendixSiteFilterSection {

    parent: IStudyAppendixSiteFilterParent;

    studies: Study[] = [];
    appendices: Appendix[] = [];
    sites: Site[] = [];

    allStudyIds: number[] = []; activeStudyIds: number[] = []; selectedStudyIds: number[] = [];
    allAppendixIds: number[] = []; activeAppendixIds: number[] = []; selectedAppendixIds: number[] = [];
    allSiteIds: number[] = []; activeSiteIds: number[] = []; selectedSiteIds: number[] = [];

    studySelectId: string;
    appendixSelectId: string;
    siteSelectId: string;

    constructor(studySelectId: string, appendixSelectId: string, siteSelectId: string, studies: Study[], appendices: Appendix[], sites: Site[], parent: IStudyAppendixSiteFilterParent) {

        this.parent = parent;

        this.studySelectId = studySelectId;
        this.appendixSelectId = appendixSelectId;
        this.siteSelectId = siteSelectId;

        this.studies = studies;
        this.appendices = appendices;
        this.sites = sites;

        if (this.studySelectId != undefined) {
            Study.SortByName(this.studies);
            this.allStudyIds = this.studies.map((s: Study) => s.Id);
        }
        if (this.appendixSelectId != undefined) {
            Appendix.SortByName(this.appendices);
            this.allAppendixIds = this.appendices.map((a: Appendix) => a.Id);
        }
        if (this.siteSelectId != undefined) this.allSiteIds = this.sites.map((s: Site) => s.Id);

        this.initializeFilters();
        this.resetFilters();
    }

    initializeFilters(): void {
        if (this.studySelectId != undefined) this.setupDropdown("study", this.studySelectId, "Platforms");
        if (this.appendixSelectId != undefined) this.setupDropdown("appendix", this.appendixSelectId, "Trials");
        if (this.siteSelectId != undefined) this.setupDropdown("site", this.siteSelectId, "Sites");
    }

    setupDropdown(type: string, elementId: string, optionName: string): void {

        $(elementId).selectpicker({
            dropupAuto: false,
            selectedTextFormat: "count",

            countSelectedText: (numSelected, numTotal) => {

                let activeCount: number = 0;
                if (type == 'study') activeCount = this.activeStudyIds.length;
                else if (type == 'appendix') activeCount = this.activeAppendixIds.length;
                else if (type == 'site') activeCount = this.activeSiteIds.length;

                if (numSelected == numTotal) {
                    return "All " + optionName + "   (n = " + numSelected + ")";
                }
                else {
                    return numSelected + " of " + activeCount + " " + optionName + " Selected";
                }
            }
        });
        $(elementId).selectpicker("refresh");

        $(elementId).on('changed.bs.select', (e, clickedIndex, isSelected, previousValue) => {
            let values: string[] = <string[]>($(elementId).val());
            this.filterDropdownOptions(type, values.map(i => Number(i)));
            $(elementId).selectpicker("refresh");
            this.filterUpdated(this.selectedStudyIds, this.selectedAppendixIds, this.selectedSiteIds);
        });
    }

    setDropdownOptions(type: string, elementId: string, selectedElementIds: number[], activeElementIds: number[], allElements: any[], optionParameterValue: string, optionParameterName: string): void {

        $(elementId).empty();

        allElements?.forEach((element: any) => {
            let selected: boolean = false;
            let disabled: boolean = false;

            if (selectedElementIds.includes(element[optionParameterValue])) {
                selected = true;
            }

            if (!activeElementIds.includes(element[optionParameterValue])) {
                disabled = true;
                selected = false;
            }

            if (!disabled) {
                let option: any = new Option(element[optionParameterName], element[optionParameterValue], false, selected);
                //option.disabled = disabled;
                $(elementId).append(option);
            }
        });
        $(elementId).selectpicker("refresh");
    }

    resetFilters(): void {
        this.selectedStudyIds = this.activeStudyIds = this.allStudyIds;
        this.selectedAppendixIds = this.activeAppendixIds = this.allAppendixIds;
        this.selectedSiteIds = this.activeSiteIds = this.allSiteIds;

        this.setDropdownOptions("study", this.studySelectId, this.selectedStudyIds, this.allStudyIds, this.studies, "Id", "Name");
        this.filterDropdownOptions("study", this.selectedStudyIds);

        this.filterUpdated(this.activeStudyIds, this.activeAppendixIds, this.activeSiteIds);
    }

    filterDropdownOptions(type: string, currentValues: number[]) {

        //console.log(type, currentValues);

        if (type == 'study') {
            this.selectedStudyIds = currentValues;
            this.activeAppendixIds = this.appendices.map((a: Appendix) => {
                if (this.selectedStudyIds.includes(a.StudyId)) return a.Id;
            }).filter((id: number) => id != undefined);
            this.activeSiteIds = this.sites?.map((s: Site) => {
                if (DoArraysOverlap(this.selectedStudyIds, s.StudyIds)) return s.Id;
            }).filter((id: number) => id != undefined);

            //cohort selection activates all hubs/sites
            this.selectedAppendixIds = this.activeAppendixIds;
            this.selectedSiteIds = this.activeSiteIds;
        }
        else if (type == 'appendix') {
            this.selectedAppendixIds = currentValues;
            //console.log(this.selectedAppendixIds);
            //sites not tied to appendices -- only to study
            //this.activeSiteIds = this.sites.map((s: Site) => {
            //    if (this.selectedHubIds.includes(s.HubId + "")) return s.Id;
            //}).filter((id: string) => id != undefined);

            //this.selectedSiteIds = this.activeSiteIds;
        }
        else if (type == 'site') {
            //no filtering "left" to study or appendix based on selected sites
            this.selectedSiteIds = currentValues;
        }

        if (type != 'study') this.setDropdownOptions("study", this.studySelectId, this.selectedStudyIds, this.allStudyIds, this.studies, "Id", "Name");
        if (type != 'appendix') this.setDropdownOptions("appendix", this.appendixSelectId, this.activeAppendixIds, this.activeAppendixIds, this.appendices, "Id", "Name");
        if (type != 'site') this.setDropdownOptions("site", this.siteSelectId, this.activeSiteIds, this.activeSiteIds, this.sites, "Id", "Name");

    }

    filterUpdated(studyIds: number[], appendixIds: number[], siteIds: number[]): void {

        //add "0" entry to signify all selected
        if (this.selectedStudyIds.length == this.activeStudyIds.length) studyIds = [0].concat(studyIds);
        if (this.selectedAppendixIds.length == this.activeAppendixIds.length) appendixIds = [0].concat(appendixIds);
        if (this.selectedSiteIds?.length == this.activeSiteIds?.length) siteIds = [0].concat(siteIds);

        this.parent.FilterUpdated(studyIds, appendixIds, siteIds);
    }

    refreshFilters(): void {
        this.filterUpdated(this.selectedStudyIds, this.selectedAppendixIds, this.selectedSiteIds);
    }
}